import React, { useCallback, useRef } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';
import { useMount } from '@cutwise/react-utils';

import FancyInput from '@/common/components/inputs/FancyInput/FancyInput';

import styles from './TreeItemInput.module.css';

interface TreeItemInputProps {
  value: string;
  onChange: (value: string) => void;
  isPendingCreation: boolean;
  isSelected: boolean;
  save: () => void;
}

function TreeItemInput(props: TreeItemInputProps) {
  const { value, onChange, isPendingCreation, isSelected, save } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  useMount(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  });

  const handleEnter = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && !isPendingCreation) {
        save();
      }
    },
    [isPendingCreation, save],
  );

  return (
    <FancyInput
      aria-label="Item title"
      value={value}
      contentClassName={cls(styles.treeItemInput, { [styles.selected]: isSelected })}
      onChange={onChange}
      onKeyDown={handleEnter}
      ref={inputRef}
    />
  );
}

export default observer(TreeItemInput);
